import { on } from '@ngrx/store';

import { JobCreateLocationsActions } from 'src/app/job/job-create/job-create-locations/job-create-locations-state.actions';
import { JobLocationsOverviewActions } from 'src/app/job/job-overview/overview-locations/overview-locations.actions';
import { NewOpportunityLocationsActions } from 'src/app/new-opportunity/new-opportunity-locations/new-opportunity-locations.actions';
import { LocationDetailsWizardActions } from 'src/app/shared/location-details-wizard/location-details-wizard.actions';

import { getNextStep, getPreviousStep } from 'src/app/shared/location-details-wizard/location-details-wizard.utils';

import {
  LocationDetailsWizardState,
  locationDetailsWizardInitialState,
} from './location-details-wizard.state';

export const locationDetailsWizardReducers = [
  on(
    JobLocationsOverviewActions.googleAutocompleteAddressSelected,
    NewOpportunityLocationsActions.googleAutocompleteAddressSelected,
    (
      state: LocationDetailsWizardState,
      { locationType, openWizard },
    ): LocationDetailsWizardState => {
      if (!openWizard) return state;

      return {
        ...state,
        locationType: locationType as 'start' | 'end',
        trigger: 'autocomplete',
      };
    },
  ),
  on(
    JobCreateLocationsActions.jobLocationsLoaded,
    JobLocationsOverviewActions.wizardDetailsLoaded,
    LocationDetailsWizardActions.overlayHidden,
    (): LocationDetailsWizardState => {
      return {
        ...locationDetailsWizardInitialState,
      };
    },
  ),
  on(
    LocationDetailsWizardActions.optionClicked,
    (state: LocationDetailsWizardState, { value }): LocationDetailsWizardState => {

      let answers = { ...state.answers };

      // If user selects new building type, reset all answers
      if (state.step === 'buildingType') {
        answers = {};
      }

      answers = {
        ...answers,
        [state.step]: value,
      }

      return {
        ...state,
        answers,
        step: getNextStep(state.step, answers),
      };
    },
  ),
  on(
    LocationDetailsWizardActions.backButtonClicked,
    (state: LocationDetailsWizardState): LocationDetailsWizardState => ({
      ...state,
      step: getPreviousStep(state.step, state.answers),
    }),
  ),
];
